import React, { useState } from 'react';
import { Container, Button, Option } from './styles';

export type Options = {
  value: string;
  id: string;
};
export interface IToggleButtons {
  firstOption: Options;
  secondOption: Options;
  onChange: (option: string) => void;
  /** The selected option's id. Without it, the buttons track the selection themselves. */
  value?: string;
}

const ToggleButtons: React.FC<IToggleButtons> = ({
  firstOption,
  secondOption,
  onChange,
  value,
}) => {
  const [toggle, setToggle] = useState(true);
  const firstActive = value === undefined ? toggle : value === firstOption.id;

  const triggerToggle = (option: string) => {
    // Clicking the active option keeps it active instead of flipping the highlight.
    setToggle(option === firstOption.id);
    onChange(option);
  };

  return (
    <Container>
      <Button
        size="small"
        $terciary
        onClick={() => triggerToggle(firstOption.id)}
        $isActive={firstActive}
      >
        <Option toggled={firstActive}>{firstOption.value}</Option>
      </Button>
      <Button
        size="small"
        $terciary
        onClick={() => triggerToggle(secondOption.id)}
        $isActive={!firstActive}
      >
        <Option toggled={!firstActive}>{secondOption.value}</Option>
      </Button>
    </Container>
  );
};

export default ToggleButtons;
